import React, { useEffect, useState } from "react";
import Header from "../../components/home/header/Header";
// import CoursesSection from "../../components/home/coursesSection/CoursesSection";
import AboutUs from "../../components/home/aboutUs/AboutUs";
import Trainers from "../../components/home/trainers/Trainers";
import Download from "../../components/home/download/Download";
import AdministrativeStaff from "../../components/home/administrativeStaff/AdministrativeStaff";
import ImagesGallery from "../../components/home/imagesGallery/ImagesGallery";
import Activities from "../../components/home/activities/Activities";
import LeaderBoards from "../../components/home/leaderBoards/LeaderBoards";
import Loader from "../../components/common/loader/Loader";
import { getFeatures } from "../../services/home.service";
import environment from "../../environment";
import { getStudentInfo } from "../../services/student.service";
import IntroModals from "../../components/home/introModals/IntroModals";
import CoursesList from "../../components/home/coursesList/CoursesList";
import { useSelector } from "react-redux";
import OurPartners from "../../components/home/ourPartners/OurPartners";

const HomeProvider = () => {
  // Get settings from store
  const data = useSelector((state) => state.setting);

  const [features, setFeatures] = useState();
  const [isFeaturesLoading, setIsFeaturesLoading] = useState(false);
  const [userData, setUserData] = useState();
  const [isDataLoading, setIsDataLoading] = useState(false);
  const _backUrl = environment.BACK_URL;
  const backUrl = localStorage.getItem(_backUrl);
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getAllFeatures = async () => {
    setIsFeaturesLoading(true);
    const response = await getFeatures();
    if (response?.status === 200) {
      setFeatures(response?.data?.data);
      setIsFeaturesLoading(false);
    } else {
      setIsFeaturesLoading(false);
    }
  };

  // get data from api
  const getData = async () => {
    setIsDataLoading(true);
    const response = await getStudentInfo();
    if (response?.status) {
      setUserData(response?.data?.data);
      setIsDataLoading(false);
    } else {
      setIsDataLoading(false);
    }
  };

  useEffect(() => {
    getAllFeatures();
    if (
      backUrl !== null &&
      backUrl !== "5" &&
      localStorage.getItem("intro-modal")
    ) {
      handleShow();
    }
    if (backUrl === 4) {
      getData();
    }
  }, [backUrl]);

  return data?.isLoading || isFeaturesLoading ? (
    <Loader height={"93vh"} />
  ) : (
    <>
      {backUrl && (
        <IntroModals
          show={show}
          handleClose={handleClose}
          backUrl={backUrl}
          userData={userData}
          isDataLoading={isDataLoading}
        />
      )}
      <Header
        // status={backUrl}
        headerData={data?.settings}
        features={features?.media}
      />
      {/* {(backUrl === "1" ||
        backUrl === "2" ||
        backUrl === "3" ||
        backUrl === "5") && <LeaderBoards />} */}
      <CoursesList />
      <LeaderBoards />
      {/* <CoursesSection /> */}
      <AboutUs features={features} />
      <Trainers />
      <Activities />
      {data.settings?.DisplayMobileSection &&
        data.settings?.DisplayMobileSection?.toLowerCase() !== "false" && (
          <Download data={data?.settings} />
        )}
      <AdministrativeStaff />
      <OurPartners />
      <ImagesGallery />
    </>
  );
};

export default HomeProvider;
